import ema from "./ema";
import { isDefined } from "../utils";
import { VolumeOscillator as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { shortCycle, longCycle, pointsOrPercent } = options;

    if (!data || data.length < Math.max(shortCycle, longCycle) + 1) {
      return [];
    }

    // Step 1: Extract volume into array, handling object format
    const volumeArray = [];
    for (let i = 0; i < data.length; i++) {
      const bar = data[i];

      if (!bar) {
        volumeArray.push(undefined);
        continue;
      }

      // Extract volume - handle both number and object format
      let vol = bar.volume;
      if (typeof vol === "object" && vol !== null) {
        vol = vol.volume;
      }

      if (!isDefined(vol) || vol <= 0) {
        volumeArray.push(undefined);
        continue;
      }

      volumeArray.push(vol);
    }

    // Step 2: Calculate short and long EMAs on volume
    const shortEMA = ema().options({
      windowSize: shortCycle,
      sourcePath: undefined,
    });

    const longEMA = ema().options({
      windowSize: longCycle,
      sourcePath: undefined,
    });

    const shortEMAArray = shortEMA(volumeArray);
    const longEMAArray = longEMA(volumeArray);

    // Step 3: Calculate oscillator value
    return data.map((d, i) => {
      const shortValue = shortEMAArray[i];
      const longValue = longEMAArray[i];

      if (!isDefined(shortValue) || !isDefined(longValue)) {
        return undefined;
      }

      if (pointsOrPercent === "Percent") {
        // Percent mode: 100 * ((Short / Long) - 1)
        return longValue !== 0 ? 100 * (shortValue / longValue - 1) : undefined;
      } else {
        // Points mode: Short - Long
        return shortValue - longValue;
      }
    });
  }

  calculator.undefinedLength = function () {
    const { longCycle } = options;
    return longCycle - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
